// extracted by mini-css-extract-plugin
module.exports = {"button":"_1t8EFRwMmk6wWXOSRBZoJ-","ios":"cQUWRac3lMlqvCbiKTOfc","iosUk":"_3aHikyefaIGJCWwGRanksN","android":"_1Xc2Ldi6IBMmXcAW7uZ-0G","androidUk":"_3Jsz3OTxMIP_jxycQz0J_h"};